<template>
  <div class="sanitas-magazine-teasers">
    <div class="sanitas-magazine-teasers__container">
      <magazine-teaser
        v-for="(teaser, i) in localTeasers"
        :key="i"
        class="teaser"
        :teaser="teaser"
      />
    </div>
  </div>
</template>

<script>
import isString from 'lodash/isString'

import MagazineTeaser from './MagazineTeaser'

export default {
  name: 'SanitasMagazineTeasers',

  components: {
    MagazineTeaser,
  },

  props: {
    teasersList: {
      type: [Array, String],
      default: () => [],
    },
    layoutOrder: {
      type: String,
      default: '1111322431',
    },
  },

  data() {
    return {
      localTeasers: [],
    }
  },

  created() {
    this.initTeaser()
  },

  methods: {
    isMobile() {
      return !this.$mq.xl
    },
    initTeaser() {
      if (this.teasersList) {
        this.localTeasers = isString(this.teasersList)
          ? JSON.parse(this.teasersList)
          : this.teasersList
        let counter = 0
        let i
        // fill up undefined widths according to predefined sequence
        for (i = 0; i < this.localTeasers.length; i++) {
          let teaser = this.localTeasers[i]
          teaser.width = parseInt(teaser.width) + ''
          if (['1', '2', '3', '4'].indexOf(teaser.width) === -1) {
            teaser.width = this.layoutOrder[counter]
            counter = (counter + 1) % this.layoutOrder.length
          }
        }

        // correct unfilled rows (the only width sequences for a full row are: 111, 31, 13, 22, 4)
        i = 0
        while (i < this.localTeasers.length) {
          if (this.localTeasers[i].width == '1') {
            if (this.localTeasers[i + 1]) {
              if (this.localTeasers[i + 1].width == '1') {
                if (this.localTeasers[i + 2]) {
                  if (this.localTeasers[i + 2].width == '1') {
                    // 111 -> ok
                    i += 3
                  } else if (this.localTeasers[i + 2].width == '2') {
                    // 112 -> 111
                    this.localTeasers[i + 2].width = '1'
                    i += 3
                  } else {
                    // 113 or 114 -> 22x
                    this.localTeasers[i].width = '2'
                    this.localTeasers[i + 1].width = '2'
                    i += 2
                  }
                } else {
                  // last row 11 -> 22
                  this.localTeasers[i].width = '2'
                  this.localTeasers[i + 1].width = '2'
                  i += 2
                }
              } else if (this.localTeasers[i + 1].width == '2') {
                // 12 -> 13
                this.localTeasers[i + 1].width = '3'
                i += 2
              } else if (this.localTeasers[i + 1].width == '3') {
                // 13 -> ok
                i += 2
              } else if (this.localTeasers[i + 1].width == '4') {
                // 14 -> 13
                this.localTeasers[i + 1].width = '3'
                i += 2
              }
            } else {
              // last row 1 -> 4
              this.localTeasers[i].width = '4'
              i += 1
            }
          } else if (this.localTeasers[i].width == '2') {
            if (this.localTeasers[i + 1]) {
              if (this.localTeasers[i + 1].width == '1') {
                // 21 -> 31
                this.localTeasers[i].width = '3'
                i += 2
              } else if (this.localTeasers[i + 1].width == '2') {
                // 22 -> ok
                i += 2
              } else if (this.localTeasers[i + 1].width == '3') {
                // 23 -> 13
                this.localTeasers[i].width = '1'
                i += 2
              } else if (this.localTeasers[i + 1].width == '4') {
                // 24 -> 13
                this.localTeasers[i].width = '1'
                this.localTeasers[i + 1].width = '3'
                i += 2
              }
            } else {
              // last row 2 -> 4
              this.localTeasers[i].width = '4'
              i += 1
            }
          } else if (this.localTeasers[i].width == '3') {
            if (this.localTeasers[i + 1]) {
              if (this.localTeasers[i + 1].width == '1') {
                // 31 -> ok
                i += 2
              } else if (this.localTeasers[i + 1].width == '2') {
                // 32 -> 31
                this.localTeasers[i + 1].width = '1'
                i += 2
              } else if (this.localTeasers[i + 1].width == '3') {
                // 33 -> 22
                this.localTeasers[i].width = '2'
                this.localTeasers[i + 1].width = '2'
                i += 2
              } else if (this.localTeasers[i + 1].width == '4') {
                // 34 -> 4
                this.localTeasers[i].width = '4'
                i += 1
              }
            } else {
              // last row 2 -> 4
              this.localTeasers[i].width = '4'
              i += 1
            }
          } else if (this.localTeasers[i].width == '4') {
            // 4 -> ok
            i += 1
          } else {
            // prevent endless loop
            i += 1
          }
        }
      }
    },
  },
}
</script>

<style lang="postcss">
.sanitas-magazine-teasers {
  margin: 0 0 40px;

  sup {
    top: -0.2em !important;
  }

  display: flex;

  &__container {
    width: 100%;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
  }

  .teaser {
    margin: 0 0 12px;
    @media (max-width: 490px) {
      margin-bottom: 10px;
    }
  }

  .magazine-teaser__tag-title {
    font-weight: 700;
    font-family: 'Open Sans', sans-serif;
    font-size: 18px;
    line-height: 24px;
  }
}
</style>
